export const GDPR_PAGE_SIZE = 50;

export function gdprPageRange(page: number): { from: number; to: number } {
  const safePage = Number.isSafeInteger(page) && page >= 0 ? page : 0;
  const from = safePage * GDPR_PAGE_SIZE;
  return { from, to: from + GDPR_PAGE_SIZE - 1 };
}

export function gdprPageCount(total: number): number {
  return Math.max(1, Math.ceil(Math.max(0, total) / GDPR_PAGE_SIZE));
}
